import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { AppComponent } from './app.component';
import { FooterComponent } from './root-components/footer/footer.component';
import { AppButtonComponent } from './root-components/app-button/app-button.component';
import { AppTextareaComponent } from './root-components/app-textarea/app-textarea.component';
import { CardComponent } from './root-components/card/card.component';
import { HomeComponent } from './pages/home-page/home.component';
import { AboutComponent } from './pages/about-page/about.component';
import { ServicesComponent } from './pages/services-page/services.component';
import { ContactComponent } from './pages/contact-page/contact.component';
import { ServiceCardComponent } from './pages/services-page/components/service-card/service-card.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { ContactFormComponent } from './pages/contact-page/components/contact-form/contact-form.component';
import { DetailsPageComponent } from './pages/details-page/details-page.component';
import { firebaseConfig } from '../../firebase-config';
import { initializeApp } from 'firebase/app';
import { PricingComponent } from './pages/pricing-page/pricing.component';
import { PricingCardComponent } from './pages/pricing-page/components/pricing-card/pricing-card.component';
import { PolicyPageComponent } from './pages/policy-page/policy-page.component';
import { VideoServiceComponent } from './pages/details-page/components/video-service/video-service.component';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { CourseDetailsComponent } from './pages/details-page/components/course-details/course-details.component';
import { AccordionModule } from 'primeng/accordion';
import { TextWithOneImageComponent } from './pages/about-page/components/text-with-one-image/text-with-one-image.component';
import { environment } from 'src/environments/environment';
import { VersionComponentComponent } from './root-components/version-component/version-component.component';
import { ButtonModule } from 'primeng/button';

import { GalleriaModule } from 'primeng/galleria';
import { TextWithImageComponent } from './pages/home-page/components/text-with-image/text-with-image.component';
import { ImageWithTextComponent } from './pages/home-page/components/image-with-text/image-with-text.component';
import { CourseComponent } from './pages/course/course.component';
import { ProfilePageComponent } from './pages/profile-page/profile-page.component';
import { UserDataComponent } from './pages/profile-page/components/user-data/user-data.component';
import { MyCoursesComponent } from './pages/profile-page/components/my-courses/my-courses.component';
import { MyPaymentsComponent } from './pages/profile-page/components/my-payments/my-payments.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ForgetPasswordComponent } from './pages/auth/forget-password/forget-password.component';
import { OtpCodeComponent } from './pages/auth/otp-code/otp-code.component';
import { SignUpComponent } from './pages/auth/sign-up/sign-up.component';
import { HeroWithOneImageComponent } from './pages/home-page/components/hero-with-one-image/hero-with-one-image.component';
import { RatingModule } from 'primeng/rating';
import { HeaderComponent } from './root-components/header/header.component';
import { TokenInterceptor } from './shared/interceptor/token-interceptor/token.interceptor';
import { RefundPolicyPageComponent } from './pages/refund-policy-page/refund-policy-page.component';
import { PaymentComponent } from './pages/payment/payment.component';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ArticlesComponent } from './pages/articles/articles.component';
import { ArticleDetailsComponent } from './pages/articles/components/article-details/article-details.component';
import { GridCardsWithFrameComponent } from './pages/home-page/components/grid-cards-with-frame/grid-cards-with-frame.component';
import { GridTextWithImageComponent } from './pages/home-page/components/grid-text-with-image/grid-text-with-image.component';
import { ServiceHeroComponent } from './pages/services-page/components/service-hero/service-hero.component';
import { OurNewsComponent } from './pages/home-page/components/our-news/our-news.component';

const app = initializeApp(firebaseConfig);
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(
    http,
    './assets/' + environment.projectName + '/i18n/',
    '.json',
  );
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    AppButtonComponent,
    AppTextareaComponent,
    CardComponent,
    HeaderComponent,
    HomeComponent,
    AboutComponent,
    ServicesComponent,
    ContactComponent,
    CourseComponent,
    ServiceCardComponent,
    ContactFormComponent,
    DetailsPageComponent,
    PricingComponent,
    GridCardsWithFrameComponent,
    PricingCardComponent,
    PolicyPageComponent,
    GridTextWithImageComponent,
    VideoServiceComponent,
    CourseDetailsComponent,
    TextWithOneImageComponent,
    VersionComponentComponent,
    TextWithImageComponent,
    ImageWithTextComponent,
    ProfilePageComponent,
    UserDataComponent,
    MyCoursesComponent,
    MyPaymentsComponent,
    LoginComponent,
    SignUpComponent,
    ResetPasswordComponent,
    OtpCodeComponent,
    ForgetPasswordComponent,
    HeroWithOneImageComponent,
    RefundPolicyPageComponent,
    PaymentComponent,
    ArticlesComponent,
    ArticleDetailsComponent,
    ServiceHeroComponent,
    OurNewsComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FontAwesomeModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    CommonModule,
    CarouselModule,
    AccordionModule,
    ButtonModule,
    RatingModule,
    GalleriaModule,
    OAuthModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
